import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const DapipInstitutionCampusViewSchema = withDefaults({
  type: 'dapip-institution-campus-view',
  fields: [
    {
      kind: 'attribute',
      name: 'dapipId',
    },
    {
      kind: 'attribute',
      name: 'parentDapipId',
    },
    {
      kind: 'attribute',
      name: 'address',
    },
    {
      kind: 'attribute',
      name: 'locationName',
    },
    {
      kind: 'attribute',
      name: 'locationType',
    },
  ],
});

export default DapipInstitutionCampusViewSchema;
